// src/data/fantacalcioListone.js
// GENERATO AUTOMATICAMENTE da src/data/fantacalcioListone.xlsx - non modificare a mano.
// Per aggiornare: sostituisci fantacalcioListone.xlsx e rilancia `npm start`/`npm run build`
// (o `npm run generate:listone`). Vedi scripts/generate-fantacalcio-listone.js.
// Usato per tradurre nome+squadra dei giocatori FantApp nell'ID che Leghe Fantacalcio
// si aspetta in fase di import rose (vedi components/auction/legheFantacalcioExport.js).

export const FANTACALCIO_LISTONE = [
  {
    "id": 5841,
    "name": "Svilar",
    "team": "Roma"
  },
  {
    "id": 4431,
    "name": "Carnesecchi",
    "team": "Atalanta"
  },
  {
    "id": 5116,
    "name": "Martinez Jo.",
    "team": "Inter"
  },
  {
    "id": 4964,
    "name": "Vicario",
    "team": "Juventus"
  },
  {
    "id": 6966,
    "name": "Butez",
    "team": "Como"
  },
  {
    "id": 4312,
    "name": "Maignan",
    "team": "Milan"
  },
  {
    "id": 2521,
    "name": "De Gea",
    "team": "Fiorentina"
  },
  {
    "id": 572,
    "name": "Meret",
    "team": "Napoli"
  },
  {
    "id": 133,
    "name": "Skorupski",
    "team": "Bologna"
  },
  {
    "id": 4360,
    "name": "Caprile",
    "team": "Cagliari"
  },
  {
    "id": 6482,
    "name": "Mandas",
    "team": "Lazio"
  },
  {
    "id": 6462,
    "name": "Okoye",
    "team": "Udinese"
  },
  {
    "id": 6534,
    "name": "Perri",
    "team": "Torino"
  },
  {
    "id": 7332,
    "name": "Bijlow",
    "team": "Genoa"
  },
  {
    "id": 2134,
    "name": "Falcone",
    "team": "Lecce"
  },
  {
    "id": 6344,
    "name": "Sanchez Ro.",
    "team": "Como"
  },
  {
    "id": 4236,
    "name": "Muric",
    "team": "Sassuolo"
  },
  {
    "id": 7411,
    "name": "Daffara",
    "team": "Parma"
  },
  {
    "id": 6248,
    "name": "Stankovic F.",
    "team": "Venezia"
  },
  {
    "id": 6415,
    "name": "Palmisani",
    "team": "Frosinone"
  },
  {
    "id": 2170,
    "name": "Milinkovic-Savic V.",
    "team": "Napoli"
  },
  {
    "id": 4485,
    "name": "Thiam",
    "team": "Monza"
  },
  {
    "id": 7463,
    "name": "Desplanches",
    "team": "Frosinone"
  },
  {
    "id": 2814,
    "name": "Provedel",
    "team": "Inter"
  },
  {
    "id": 6662,
    "name": "Corvi",
    "team": "Parma"
  },
  {
    "id": 4,
    "name": "Sportiello",
    "team": "Atalanta"
  },
  {
    "id": 7533,
    "name": "Happonen",
    "team": "Bologna"
  },
  {
    "id": 7172,
    "name": "Pessina Mas.",
    "team": "Bologna"
  },
  {
    "id": 6650,
    "name": "Sherri",
    "team": "Cagliari"
  },
  {
    "id": 7301,
    "name": "Tornqvist",
    "team": "Monza"
  },
  {
    "id": 2809,
    "name": "Vigorito",
    "team": "Como"
  },
  {
    "id": 6403,
    "name": "Christensen O.",
    "team": "Fiorentina"
  },
  {
    "id": 158,
    "name": "Lezzerini",
    "team": "Fiorentina"
  },
  {
    "id": 7466,
    "name": "Lolic",
    "team": "Frosinone"
  },
  {
    "id": 219,
    "name": "Sommariva",
    "team": "Genoa"
  },
  {
    "id": 6569,
    "name": "Stolz",
    "team": "Genoa"
  },
  {
    "id": 1926,
    "name": "Di Gennaro",
    "team": "Inter"
  },
  {
    "id": 1930,
    "name": "Pinsoglio",
    "team": "Juventus"
  },
  {
    "id": 7337,
    "name": "Motta",
    "team": "Lazio"
  },
  {
    "id": 7534,
    "name": "Renzetti",
    "team": "Lazio"
  },
  {
    "id": 2815,
    "name": "Terracciano",
    "team": "Milan"
  },
  {
    "id": 6813,
    "name": "Torriani",
    "team": "Milan"
  },
  {
    "id": 7475,
    "name": "Strajnar",
    "team": "Monza"
  },
  {
    "id": 2845,
    "name": "Contini",
    "team": "Napoli"
  },
  {
    "id": 7048,
    "name": "De Marzi",
    "team": "Roma"
  },
  {
    "id": 610,
    "name": "Gollini",
    "team": "Roma"
  },
  {
    "id": 4518,
    "name": "Russo A.",
    "team": "Sassuolo"
  },
  {
    "id": 4867,
    "name": "Turati",
    "team": "Sassuolo"
  },
  {
    "id": 7457,
    "name": "Mascardi",
    "team": "Torino"
  },
  {
    "id": 7363,
    "name": "Siviero",
    "team": "Torino"
  },
  {
    "id": 543,
    "name": "Padelli",
    "team": "Udinese"
  },
  {
    "id": 5707,
    "name": "Piana",
    "team": "Udinese"
  },
  {
    "id": 6671,
    "name": "Grandi",
    "team": "Venezia"
  },
  {
    "id": 7531,
    "name": "Pozzi",
    "team": "Venezia"
  },
  {
    "id": 2127,
    "name": "Satalino",
    "team": "Sassuolo"
  },
  {
    "id": 7557,
    "name": "Penev",
    "team": "Lecce"
  },
  {
    "id": 7560,
    "name": "Pisseri",
    "team": "Frosinone"
  },
  {
    "id": 3,
    "name": "Radunovic",
    "team": "Cagliari"
  },
  {
    "id": 4957,
    "name": "Montipò",
    "team": "Venezia"
  },
  {
    "id": 4468,
    "name": "Bleve",
    "team": "Lecce"
  },
  {
    "id": 7603,
    "name": "Grabara",
    "team": "Juventus"
  },
  {
    "id": 7611,
    "name": "Mrozek",
    "team": "Udinese"
  },
  {
    "id": 2874,
    "name": "Ghidotti",
    "team": "Parma"
  },
  {
    "id": 7626,
    "name": "Pompei",
    "team": "Atalanta"
  },
  {
    "id": 254,
    "name": "Dimarco",
    "team": "Inter"
  },
  {
    "id": 7181,
    "name": "Wesley",
    "team": "Roma"
  },
  {
    "id": 4998,
    "name": "Molina N.",
    "team": "Roma"
  },
  {
    "id": 2788,
    "name": "Bremer",
    "team": "Juventus"
  },
  {
    "id": 2296,
    "name": "Mancini",
    "team": "Roma"
  },
  {
    "id": 4159,
    "name": "Akanji",
    "team": "Inter"
  },
  {
    "id": 4409,
    "name": "Rrahmani",
    "team": "Napoli"
  },
  {
    "id": 2120,
    "name": "Bastoni",
    "team": "Inter"
  },
  {
    "id": 4976,
    "name": "Kalulu",
    "team": "Juventus"
  },
  {
    "id": 5022,
    "name": "Pavlovic",
    "team": "Milan"
  },
  {
    "id": 5833,
    "name": "Gila",
    "team": "Milan"
  },
  {
    "id": 4317,
    "name": "N'Dicka",
    "team": "Roma"
  },
  {
    "id": 6956,
    "name": "Solet",
    "team": "Udinese"
  },
  {
    "id": 6217,
    "name": "Bisseck",
    "team": "Inter"
  },
  {
    "id": 2514,
    "name": "Stones",
    "team": "Inter"
  },
  {
    "id": 2816,
    "name": "Di Lorenzo",
    "team": "Napoli"
  },
  {
    "id": 5750,
    "name": "Ostigard",
    "team": "Genoa"
  },
  {
    "id": 4807,
    "name": "Hermoso",
    "team": "Roma"
  },
  {
    "id": 5982,
    "name": "Spence",
    "team": "Inter"
  },
  {
    "id": 5526,
    "name": "Scalvini",
    "team": "Atalanta"
  },
  {
    "id": 6869,
    "name": "Ramon",
    "team": "Como"
  },
  {
    "id": 5641,
    "name": "Chalobah T.",
    "team": "Como"
  },
  {
    "id": 5885,
    "name": "Dodò",
    "team": "Fiorentina"
  },
  {
    "id": 5514,
    "name": "Vasquez",
    "team": "Genoa"
  },
  {
    "id": 4994,
    "name": "Vojvoda",
    "team": "Udinese"
  },
  {
    "id": 5555,
    "name": "Kamara H.",
    "team": "Udinese"
  },
  {
    "id": 554,
    "name": "Zappacosta",
    "team": "Atalanta"
  },
  {
    "id": 4734,
    "name": "Miranda J.",
    "team": "Bologna"
  },
  {
    "id": 4657,
    "name": "Celik",
    "team": "Juventus"
  },
  {
    "id": 5520,
    "name": "Cambiaso",
    "team": "Juventus"
  },
  {
    "id": 6320,
    "name": "Doekhi",
    "team": "Lazio"
  },
  {
    "id": 6989,
    "name": "Tiago Gabriel",
    "team": "Lecce"
  },
  {
    "id": 6496,
    "name": "Bartesaghi",
    "team": "Milan"
  },
  {
    "id": 1852,
    "name": "Spinazzola",
    "team": "Napoli"
  },
  {
    "id": 6664,
    "name": "Delprato",
    "team": "Parma"
  },
  {
    "id": 5862,
    "name": "Valeri",
    "team": "Parma"
  },
  {
    "id": 7529,
    "name": "Koulierakis",
    "team": "Roma"
  },
  {
    "id": 6495,
    "name": "Comuzzo",
    "team": "Torino"
  },
  {
    "id": 6727,
    "name": "Couto",
    "team": "Como"
  },
  {
    "id": 5675,
    "name": "Theate",
    "team": "Bologna"
  },
  {
    "id": 4137,
    "name": "Diego Carlos",
    "team": "Parma"
  },
  {
    "id": 6046,
    "name": "Hien",
    "team": "Atalanta"
  },
  {
    "id": 6042,
    "name": "Lucumì",
    "team": "Juventus"
  },
  {
    "id": 4433,
    "name": "Zortea",
    "team": "Bologna"
  },
  {
    "id": 4210,
    "name": "Mina",
    "team": "Cagliari"
  },
  {
    "id": 5701,
    "name": "Obert",
    "team": "Cagliari"
  },
  {
    "id": 5365,
    "name": "Dragusin",
    "team": "Fiorentina"
  },
  {
    "id": 6531,
    "name": "Jimenez A.",
    "team": "Fiorentina"
  },
  {
    "id": 7469,
    "name": "Bracaglia",
    "team": "Frosinone"
  },
  {
    "id": 5620,
    "name": "Tavares N.",
    "team": "Lazio"
  },
  {
    "id": 4401,
    "name": "Gabbia",
    "team": "Milan"
  },
  {
    "id": 7485,
    "name": "Mangas",
    "team": "Monza"
  },
  {
    "id": 6672,
    "name": "Idzes",
    "team": "Sassuolo"
  },
  {
    "id": 6642,
    "name": "Coco",
    "team": "Torino"
  },
  {
    "id": 5010,
    "name": "Ismajli",
    "team": "Torino"
  },
  {
    "id": 4664,
    "name": "Badiashile",
    "team": "Napoli"
  },
  {
    "id": 7580,
    "name": "Sutalo J.",
    "team": "Lazio"
  },
  {
    "id": 7220,
    "name": "Belghali",
    "team": "Torino"
  },
  {
    "id": 2640,
    "name": "Kolasinac",
    "team": "Atalanta"
  },
  {
    "id": 4887,
    "name": "Bellanova",
    "team": "Atalanta"
  },
  {
    "id": 7219,
    "name": "Bernasconi",
    "team": "Atalanta"
  },
  {
    "id": 7212,
    "name": "Heggem",
    "team": "Bologna"
  },
  {
    "id": 5678,
    "name": "Holm",
    "team": "Bologna"
  },
  {
    "id": 7414,
    "name": "Kaiki",
    "team": "Como"
  },
  {
    "id": 6867,
    "name": "Valle",
    "team": "Como"
  },
  {
    "id": 7410,
    "name": "Viery",
    "team": "Fiorentina"
  },
  {
    "id": 4952,
    "name": "Monterisi",
    "team": "Frosinone"
  },
  {
    "id": 6238,
    "name": "Oyono A.",
    "team": "Frosinone"
  },
  {
    "id": 6660,
    "name": "Marcandalli",
    "team": "Genoa"
  },
  {
    "id": 4177,
    "name": "Pavard",
    "team": "Inter"
  },
  {
    "id": 5877,
    "name": "Carlos Augusto",
    "team": "Inter"
  },
  {
    "id": 4817,
    "name": "Pedraza",
    "team": "Lazio"
  },
  {
    "id": 2188,
    "name": "Marusic",
    "team": "Lazio"
  },
  {
    "id": 6990,
    "name": "Veiga D.",
    "team": "Lecce"
  },
  {
    "id": 4502,
    "name": "Gallo",
    "team": "Lecce"
  },
  {
    "id": 4751,
    "name": "Tomori",
    "team": "Milan"
  },
  {
    "id": 6202,
    "name": "Beukema",
    "team": "Napoli"
  },
  {
    "id": 2724,
    "name": "Buongiorno",
    "team": "Napoli"
  },
  {
    "id": 6485,
    "name": "Kristensen T.",
    "team": "Atalanta"
  },
  {
    "id": 7329,
    "name": "Obrador",
    "team": "Sassuolo"
  },
  {
    "id": 7069,
    "name": "Fortini",
    "team": "Torino"
  },
  {
    "id": 7564,
    "name": "Leysen F.",
    "team": "Sassuolo"
  },
  {
    "id": 4705,
    "name": "Balerdi",
    "team": "Roma"
  },
  {
    "id": 4147,
    "name": "Caleta-Car",
    "team": "Sassuolo"
  },
  {
    "id": 7621,
    "name": "Sugawara",
    "team": "Cagliari"
  },
  {
    "id": 7532,
    "name": "Kofler",
    "team": "Cagliari"
  },
  {
    "id": 7274,
    "name": "Zè Pedro",
    "team": "Cagliari"
  },
  {
    "id": 6893,
    "name": "Kempf",
    "team": "Como"
  },
  {
    "id": 7294,
    "name": "Valdepenas",
    "team": "Fiorentina"
  },
  {
    "id": 7467,
    "name": "Calvani",
    "team": "Frosinone"
  },
  {
    "id": 6766,
    "name": "Kelly L.",
    "team": "Juventus"
  },
  {
    "id": 6632,
    "name": "Gaspar K.",
    "team": "Lecce"
  },
  {
    "id": 5739,
    "name": "De Winter",
    "team": "Milan"
  },
  {
    "id": 5840,
    "name": "Olivera",
    "team": "Napoli"
  },
  {
    "id": 6631,
    "name": "Ghilardi",
    "team": "Roma"
  },
  {
    "id": 5851,
    "name": "Doig",
    "team": "Sassuolo"
  },
  {
    "id": 7253,
    "name": "Bella-Kotchap",
    "team": "Venezia"
  },
  {
    "id": 4845,
    "name": "Correia T.",
    "team": "Venezia"
  },
  {
    "id": 5695,
    "name": "Haps",
    "team": "Venezia"
  },
  {
    "id": 5751,
    "name": "Patterson",
    "team": "Torino"
  },
  {
    "id": 2169,
    "name": "Rodriguez R.",
    "team": "Torino"
  },
  {
    "id": 5578,
    "name": "Kossounou",
    "team": "Atalanta"
  },
  {
    "id": 7068,
    "name": "Vitik",
    "team": "Bologna"
  },
  {
    "id": 7268,
    "name": "Rodriguez Ju.",
    "team": "Cagliari"
  },
  {
    "id": 7014,
    "name": "Smolcic I.",
    "team": "Como"
  },
  {
    "id": 5603,
    "name": "Pongracic",
    "team": "Fiorentina"
  },
  {
    "id": 5449,
    "name": "Parisi",
    "team": "Fiorentina"
  },
  {
    "id": 5757,
    "name": "Cittadini",
    "team": "Frosinone"
  },
  {
    "id": 7537,
    "name": "Mitaj",
    "team": "Genoa"
  },
  {
    "id": 5831,
    "name": "Gatti",
    "team": "Juventus"
  },
  {
    "id": 7012,
    "name": "Provstgaard",
    "team": "Lazio"
  },
  {
    "id": 7131,
    "name": "Floriani Mussolini",
    "team": "Lazio"
  },
  {
    "id": 7240,
    "name": "Siebert",
    "team": "Lecce"
  },
  {
    "id": 5838,
    "name": "Birindelli",
    "team": "Monza"
  },
  {
    "id": 5307,
    "name": "Valenti",
    "team": "Parma"
  },
  {
    "id": 6986,
    "name": "Rensch",
    "team": "Roma"
  },
  {
    "id": 4374,
    "name": "Walukiewicz",
    "team": "Sassuolo"
  },
  {
    "id": 7526,
    "name": "Comert",
    "team": "Torino"
  },
  {
    "id": 4263,
    "name": "Kabasele",
    "team": "Udinese"
  },
  {
    "id": 5820,
    "name": "Bertola",
    "team": "Udinese"
  },
  {
    "id": 5527,
    "name": "Zanoli",
    "team": "Udinese"
  },
  {
    "id": 7312,
    "name": "Arizala",
    "team": "Udinese"
  },
  {
    "id": 6890,
    "name": "Moreno M.",
    "team": "Venezia"
  },
  {
    "id": 6821,
    "name": "Hainaut",
    "team": "Venezia"
  },
  {
    "id": 4375,
    "name": "Terzic",
    "team": "Frosinone"
  },
  {
    "id": 7563,
    "name": "Favasuli",
    "team": "Napoli"
  },
  {
    "id": 256,
    "name": "Juan Jesus",
    "team": "Venezia"
  },
  {
    "id": 6047,
    "name": "Ehizibue",
    "team": "Genoa"
  },
  {
    "id": 5498,
    "name": "Casale",
    "team": "Bologna"
  },
  {
    "id": 7326,
    "name": "Helland",
    "team": "Bologna"
  },
  {
    "id": 7125,
    "name": "Idrissi R.",
    "team": "Cagliari"
  },
  {
    "id": 4378,
    "name": "Ranieri L.",
    "team": "Fiorentina"
  },
  {
    "id": 7175,
    "name": "Joao Mario",
    "team": "Fiorentina"
  },
  {
    "id": 7540,
    "name": "Akpoguma",
    "team": "Frosinone"
  },
  {
    "id": 5273,
    "name": "Estupinan",
    "team": "Milan"
  },
  {
    "id": 6659,
    "name": "Lucchesi",
    "team": "Monza"
  },
  {
    "id": 7238,
    "name": "Kouadio",
    "team": "Monza"
  },
  {
    "id": 4925,
    "name": "Carboni A.",
    "team": "Monza"
  },
  {
    "id": 7235,
    "name": "Troilo",
    "team": "Parma"
  },
  {
    "id": 7255,
    "name": "Britschgi",
    "team": "Parma"
  },
  {
    "id": 6985,
    "name": "Candè",
    "team": "Sassuolo"
  },
  {
    "id": 6925,
    "name": "Palma",
    "team": "Udinese"
  },
  {
    "id": 5994,
    "name": "Ebosse",
    "team": "Udinese"
  },
  {
    "id": 7538,
    "name": "Halhal",
    "team": "Venezia"
  },
  {
    "id": 6892,
    "name": "Schingtienne",
    "team": "Venezia"
  },
  {
    "id": 6673,
    "name": "Sverko",
    "team": "Venezia"
  },
  {
    "id": 7478,
    "name": "Franjic",
    "team": "Venezia"
  },
  {
    "id": 7154,
    "name": "Odenthal",
    "team": "Sassuolo"
  },
  {
    "id": 7605,
    "name": "Tchato",
    "team": "Frosinone"
  },
  {
    "id": 6601,
    "name": "Kambwala",
    "team": "Como"
  },
  {
    "id": 5742,
    "name": "Drameh",
    "team": "Genoa"
  },
  {
    "id": 7483,
    "name": "Alhassane",
    "team": "Bologna"
  },
  {
    "id": 6896,
    "name": "Van Der Brempt",
    "team": "Sassuolo"
  },
  {
    "id": 6977,
    "name": "Otoa",
    "team": "Genoa"
  },
  {
    "id": 7413,
    "name": "Puczka",
    "team": "Genoa"
  },
  {
    "id": 791,
    "name": "Sabelli",
    "team": "Genoa"
  },
  {
    "id": 2263,
    "name": "Lazzari",
    "team": "Lazio"
  },
  {
    "id": 2728,
    "name": "Pellegrini Lu.",
    "team": "Lazio"
  },
  {
    "id": 6883,
    "name": "Jean",
    "team": "Lecce"
  },
  {
    "id": 7182,
    "name": "Ndaba",
    "team": "Lecce"
  },
  {
    "id": 7525,
    "name": "Diawara S.",
    "team": "Milan"
  },
  {
    "id": 7476,
    "name": "Bakoune",
    "team": "Monza"
  },
  {
    "id": 6638,
    "name": "Marin R.",
    "team": "Napoli"
  },
  {
    "id": 7202,
    "name": "Ndiaye",
    "team": "Parma"
  },
  {
    "id": 252,
    "name": "Biraghi",
    "team": "Torino"
  },
  {
    "id": 6021,
    "name": "Abankwah",
    "team": "Udinese"
  },
  {
    "id": 6681,
    "name": "Sagrado",
    "team": "Venezia"
  },
  {
    "id": 7548,
    "name": "Aurelio",
    "team": "Cagliari"
  },
  {
    "id": 6537,
    "name": "Goglichidze",
    "team": "Monza"
  },
  {
    "id": 7573,
    "name": "Cinquegrano",
    "team": "Sassuolo"
  },
  {
    "id": 5812,
    "name": "Terracciano F.",
    "team": "Milan"
  },
  {
    "id": 7599,
    "name": "Lulli",
    "team": "Roma"
  },
  {
    "id": 7615,
    "name": "Drobnic",
    "team": "Parma"
  },
  {
    "id": 487,
    "name": "De Silvestri",
    "team": "Bologna"
  },
  {
    "id": 418,
    "name": "Goldaniga",
    "team": "Como"
  },
  {
    "id": 5424,
    "name": "Amey",
    "team": "Frosinone"
  },
  {
    "id": 294,
    "name": "Rugani",
    "team": "Juventus"
  },
  {
    "id": 6039,
    "name": "Cabal",
    "team": "Juventus"
  },
  {
    "id": 327,
    "name": "Patric",
    "team": "Lazio"
  },
  {
    "id": 5399,
    "name": "Antov",
    "team": "Monza"
  },
  {
    "id": 6809,
    "name": "Marianucci",
    "team": "Napoli"
  },
  {
    "id": 5481,
    "name": "Mazzocchi",
    "team": "Venezia"
  },
  {
    "id": 6149,
    "name": "Carboni F.",
    "team": "Parma"
  },
  {
    "id": 7260,
    "name": "Ziolkowski",
    "team": "Monza"
  },
  {
    "id": 7156,
    "name": "Pieragnolo",
    "team": "Sassuolo"
  },
  {
    "id": 7454,
    "name": "Gomes",
    "team": "Venezia"
  },
  {
    "id": 7553,
    "name": "Omar Fayed",
    "team": "Frosinone"
  },
  {
    "id": 7604,
    "name": "Maye",
    "team": "Monza"
  },
  {
    "id": 6826,
    "name": "Dembelè A.",
    "team": "Lecce"
  },
  {
    "id": 6875,
    "name": "Paz N.",
    "team": "Como"
  },
  {
    "id": 2194,
    "name": "Calhanoglu",
    "team": "Inter"
  },
  {
    "id": 4777,
    "name": "McTominay",
    "team": "Napoli"
  },
  {
    "id": 2167,
    "name": "Orsolini",
    "team": "Bologna"
  },
  {
    "id": 2423,
    "name": "Pulisic",
    "team": "Milan"
  },
  {
    "id": 2379,
    "name": "Rabiot",
    "team": "Milan"
  },
  {
    "id": 7126,
    "name": "Baturina",
    "team": "Como"
  },
  {
    "id": 7556,
    "name": "Mora",
    "team": "Roma"
  },
  {
    "id": 5559,
    "name": "Da Cunha",
    "team": "Como"
  },
  {
    "id": 1870,
    "name": "Barella",
    "team": "Inter"
  },
  {
    "id": 2766,
    "name": "Zaniolo",
    "team": "Udinese"
  },
  {
    "id": 4973,
    "name": "McKennie",
    "team": "Juventus"
  },
  {
    "id": 2517,
    "name": "De Bruyne",
    "team": "Napoli"
  },
  {
    "id": 632,
    "name": "Zaccagni",
    "team": "Lazio"
  },
  {
    "id": 6908,
    "name": "Atta",
    "team": "Fiorentina"
  },
  {
    "id": 5119,
    "name": "Samardzic",
    "team": "Atalanta"
  },
  {
    "id": 6884,
    "name": "Conceicao",
    "team": "Juventus"
  },
  {
    "id": 7314,
    "name": "Taylor K.",
    "team": "Lazio"
  },
  {
    "id": 5687,
    "name": "Vlasic",
    "team": "Torino"
  },
  {
    "id": 5792,
    "name": "Ederson D.S.",
    "team": "Atalanta"
  },
  {
    "id": 5800,
    "name": "Gudmundsson A.",
    "team": "Lazio"
  },
  {
    "id": 152,
    "name": "Zielinski",
    "team": "Inter"
  },
  {
    "id": 2606,
    "name": "Modric",
    "team": "Milan"
  },
  {
    "id": 6684,
    "name": "Ekkelenkamp",
    "team": "Udinese"
  },
  {
    "id": 5172,
    "name": "Jones C.",
    "team": "Inter"
  },
  {
    "id": 4179,
    "name": "Gonzalez N.",
    "team": "Juventus"
  },
  {
    "id": 1850,
    "name": "Kessiè",
    "team": "Atalanta"
  },
  {
    "id": 7625,
    "name": "Goncalves P.",
    "team": "Fiorentina"
  },
  {
    "id": 7129,
    "name": "Rodriguez Je.",
    "team": "Como"
  },
  {
    "id": 5823,
    "name": "Baldanzi",
    "team": "Genoa"
  },
  {
    "id": 7436,
    "name": "Alajbegovic",
    "team": "Juventus"
  },
  {
    "id": 4892,
    "name": "Saelemaekers",
    "team": "Milan"
  },
  {
    "id": 7078,
    "name": "Mastantuono",
    "team": "Fiorentina"
  },
  {
    "id": 6372,
    "name": "Moreira",
    "team": "Milan"
  },
  {
    "id": 184,
    "name": "Bernardeschi",
    "team": "Bologna"
  },
  {
    "id": 6844,
    "name": "Rowe",
    "team": "Atalanta"
  },
  {
    "id": 6151,
    "name": "Perrone",
    "team": "Como"
  },
  {
    "id": 2848,
    "name": "Frattesi",
    "team": "Lazio"
  },
  {
    "id": 4220,
    "name": "Zambo Anguissa",
    "team": "Napoli"
  },
  {
    "id": 7223,
    "name": "Vergara",
    "team": "Napoli"
  },
  {
    "id": 5589,
    "name": "Konè M.",
    "team": "Roma"
  },
  {
    "id": 5844,
    "name": "Thorstvedt",
    "team": "Sassuolo"
  },
  {
    "id": 6274,
    "name": "Diouf",
    "team": "Inter"
  },
  {
    "id": 7070,
    "name": "Sucic P.",
    "team": "Inter"
  },
  {
    "id": 827,
    "name": "Locatelli",
    "team": "Juventus"
  },
  {
    "id": 5562,
    "name": "Thuram K.",
    "team": "Juventus"
  },
  {
    "id": 5500,
    "name": "Cancellieri",
    "team": "Lazio"
  },
  {
    "id": 6398,
    "name": "Isaksen",
    "team": "Lazio"
  },
  {
    "id": 5878,
    "name": "Colpani",
    "team": "Monza"
  },
  {
    "id": 536,
    "name": "Politano",
    "team": "Napoli"
  },
  {
    "id": 779,
    "name": "Cristante",
    "team": "Roma"
  },
  {
    "id": 5735,
    "name": "Volpato",
    "team": "Sassuolo"
  },
  {
    "id": 5888,
    "name": "Casadei",
    "team": "Torino"
  },
  {
    "id": 530,
    "name": "Pellegrini Lo.",
    "team": "Roma"
  },
  {
    "id": 2077,
    "name": "Pasalic",
    "team": "Atalanta"
  },
  {
    "id": 2765,
    "name": "Odgaard",
    "team": "Bologna"
  },
  {
    "id": 4436,
    "name": "Cambiaghi",
    "team": "Bologna"
  },
  {
    "id": 1933,
    "name": "Mandragora",
    "team": "Torino"
  },
  {
    "id": 7472,
    "name": "Calò",
    "team": "Frosinone"
  },
  {
    "id": 4856,
    "name": "Chukwueze",
    "team": "Milan"
  },
  {
    "id": 4287,
    "name": "Lobotka",
    "team": "Napoli"
  },
  {
    "id": 6717,
    "name": "Konè I.",
    "team": "Sassuolo"
  },
  {
    "id": 7551,
    "name": "Schmid",
    "team": "Frosinone"
  },
  {
    "id": 7618,
    "name": "Hutchinson",
    "team": "Milan"
  },
  {
    "id": 6833,
    "name": "Mbangula",
    "team": "Bologna"
  },
  {
    "id": 4364,
    "name": "Gaetano",
    "team": "Atalanta"
  },
  {
    "id": 5422,
    "name": "Zalewski",
    "team": "Atalanta"
  },
  {
    "id": 5858,
    "name": "Ferguson",
    "team": "Bologna"
  },
  {
    "id": 4870,
    "name": "Adopo",
    "team": "Cagliari"
  },
  {
    "id": 7311,
    "name": "Romano",
    "team": "Cagliari"
  },
  {
    "id": 4465,
    "name": "Fagioli",
    "team": "Fiorentina"
  },
  {
    "id": 6294,
    "name": "Ndour",
    "team": "Fiorentina"
  },
  {
    "id": 5791,
    "name": "Frendrup",
    "team": "Genoa"
  },
  {
    "id": 5685,
    "name": "Koopmeiners",
    "team": "Juventus"
  },
  {
    "id": 4459,
    "name": "Rovella",
    "team": "Lazio"
  },
  {
    "id": 5504,
    "name": "Coulibaly L.",
    "team": "Lecce"
  },
  {
    "id": 6593,
    "name": "Akinsanmiro",
    "team": "Monza"
  },
  {
    "id": 6666,
    "name": "Bernabè",
    "team": "Parma"
  },
  {
    "id": 6190,
    "name": "Pisilli",
    "team": "Roma"
  },
  {
    "id": 6680,
    "name": "Karlstrom",
    "team": "Udinese"
  },
  {
    "id": 6783,
    "name": "Unai Gomez",
    "team": "Udinese"
  },
  {
    "id": 5946,
    "name": "Sow",
    "team": "Genoa"
  },
  {
    "id": 4479,
    "name": "Elmas",
    "team": "Atalanta"
  },
  {
    "id": 7619,
    "name": "Monteiro J.",
    "team": "Lecce"
  },
  {
    "id": 5680,
    "name": "Sarr P.",
    "team": "Juventus"
  },
  {
    "id": 795,
    "name": "El Shaarawy",
    "team": "Genoa"
  },
  {
    "id": 5298,
    "name": "Pobega",
    "team": "Bologna"
  },
  {
    "id": 4260,
    "name": "Winks",
    "team": "Cagliari"
  },
  {
    "id": 6010,
    "name": "Fazzini",
    "team": "Cagliari"
  },
  {
    "id": 7412,
    "name": "Milla",
    "team": "Como"
  },
  {
    "id": 5036,
    "name": "Caqueret",
    "team": "Como"
  },
  {
    "id": 6678,
    "name": "Liberali",
    "team": "Como"
  },
  {
    "id": 7464,
    "name": "Oulai",
    "team": "Fiorentina"
  },
  {
    "id": 5998,
    "name": "Zerbin",
    "team": "Frosinone"
  },
  {
    "id": 6020,
    "name": "Ellertsson",
    "team": "Genoa"
  },
  {
    "id": 5761,
    "name": "Zhegrova",
    "team": "Juventus"
  },
  {
    "id": 6549,
    "name": "Pierotti",
    "team": "Lecce"
  },
  {
    "id": 2741,
    "name": "Pessina",
    "team": "Monza"
  },
  {
    "id": 4349,
    "name": "Nicolussi Caviglia",
    "team": "Parma"
  },
  {
    "id": 2528,
    "name": "Matic",
    "team": "Sassuolo"
  },
  {
    "id": 6677,
    "name": "Adzic",
    "team": "Sassuolo"
  },
  {
    "id": 7036,
    "name": "Bakola",
    "team": "Sassuolo"
  },
  {
    "id": 7060,
    "name": "Cacciamani",
    "team": "Torino"
  },
  {
    "id": 6218,
    "name": "Oristanio",
    "team": "Torino"
  },
  {
    "id": 7198,
    "name": "Piotrowski",
    "team": "Udinese"
  },
  {
    "id": 5674,
    "name": "Basic",
    "team": "Venezia"
  },
  {
    "id": 7146,
    "name": "Tourè I.",
    "team": "Monza"
  },
  {
    "id": 7624,
    "name": "Braganca",
    "team": "Torino"
  },
  {
    "id": 7528,
    "name": "Amondarain",
    "team": "Bologna"
  },
  {
    "id": 6640,
    "name": "Felici",
    "team": "Cagliari"
  },
  {
    "id": 7409,
    "name": "Meichtry",
    "team": "Genoa"
  },
  {
    "id": 5301,
    "name": "Luis Henrique",
    "team": "Inter"
  },
  {
    "id": 6629,
    "name": "Dele-Bashiru",
    "team": "Lazio"
  },
  {
    "id": 7203,
    "name": "Jashari",
    "team": "Milan"
  },
  {
    "id": 6898,
    "name": "Keita M.",
    "team": "Parma"
  },
  {
    "id": 7535,
    "name": "Fitz-Jim",
    "team": "Torino"
  },
  {
    "id": 6170,
    "name": "Gineitis",
    "team": "Torino"
  },
  {
    "id": 5507,
    "name": "Busio",
    "team": "Venezia"
  },
  {
    "id": 5319,
    "name": "Sohm",
    "team": "Venezia"
  },
  {
    "id": 6994,
    "name": "Perez K.",
    "team": "Venezia"
  },
  {
    "id": 6618,
    "name": "Cissè A.",
    "team": "Milan"
  },
  {
    "id": 22,
    "name": "De Roon",
    "team": "Roma"
  },
  {
    "id": 6054,
    "name": "Moro N.",
    "team": "Bologna"
  },
  {
    "id": 6895,
    "name": "Dominguez B.",
    "team": "Sassuolo"
  },
  {
    "id": 7127,
    "name": "Addai",
    "team": "Como"
  },
  {
    "id": 6206,
    "name": "Fabbian",
    "team": "Parma"
  },
  {
    "id": 7473,
    "name": "Cichella",
    "team": "Frosinone"
  },
  {
    "id": 6506,
    "name": "Fini",
    "team": "Frosinone"
  },
  {
    "id": 7341,
    "name": "Amorim",
    "team": "Genoa"
  },
  {
    "id": 4970,
    "name": "Messias",
    "team": "Genoa"
  },
  {
    "id": 2857,
    "name": "Traorè Hj.",
    "team": "Genoa"
  },
  {
    "id": 2529,
    "name": "Mkhitaryan",
    "team": "Inter"
  },
  {
    "id": 4911,
    "name": "Douglas Luiz",
    "team": "Juventus"
  },
  {
    "id": 333,
    "name": "Cataldi",
    "team": "Lazio"
  },
  {
    "id": 7322,
    "name": "Ngom",
    "team": "Lecce"
  },
  {
    "id": 6015,
    "name": "Berisha M.",
    "team": "Lecce"
  },
  {
    "id": 7318,
    "name": "Gandelman",
    "team": "Lecce"
  },
  {
    "id": 5453,
    "name": "Ricci S.",
    "team": "Como"
  },
  {
    "id": 4199,
    "name": "Loftus-Cheek",
    "team": "Milan"
  },
  {
    "id": 6252,
    "name": "Folorunsho",
    "team": "Monza"
  },
  {
    "id": 6207,
    "name": "Almqvist",
    "team": "Parma"
  },
  {
    "id": 6005,
    "name": "Ilkhan",
    "team": "Torino"
  },
  {
    "id": 6827,
    "name": "Njie",
    "team": "Fiorentina"
  },
  {
    "id": 7208,
    "name": "Miller L.",
    "team": "Udinese"
  },
  {
    "id": 7550,
    "name": "Grillitsch",
    "team": "Frosinone"
  },
  {
    "id": 7579,
    "name": "Massolin",
    "team": "Cagliari"
  },
  {
    "id": 6024,
    "name": "Sulemana I.",
    "team": "Sassuolo"
  },
  {
    "id": 1871,
    "name": "Deiola",
    "team": "Cagliari"
  },
  {
    "id": 4947,
    "name": "Brescianini",
    "team": "Fiorentina"
  },
  {
    "id": 6241,
    "name": "Gelli F.",
    "team": "Frosinone"
  },
  {
    "id": 6917,
    "name": "Masini",
    "team": "Frosinone"
  },
  {
    "id": 6503,
    "name": "Stankovic A.",
    "team": "Inter"
  },
  {
    "id": 7248,
    "name": "Gorter",
    "team": "Lecce"
  },
  {
    "id": 5457,
    "name": "Maleh",
    "team": "Lecce"
  },
  {
    "id": 5295,
    "name": "Musah",
    "team": "Milan"
  },
  {
    "id": 7477,
    "name": "Colombo L.",
    "team": "Monza"
  },
  {
    "id": 5131,
    "name": "Gilmour",
    "team": "Napoli"
  },
  {
    "id": 7138,
    "name": "Ordonez C.",
    "team": "Parma"
  },
  {
    "id": 7536,
    "name": "Diallo O.",
    "team": "Parma"
  },
  {
    "id": 7183,
    "name": "Aboukhlal",
    "team": "Torino"
  },
  {
    "id": 5872,
    "name": "Helgason",
    "team": "Venezia"
  },
  {
    "id": 801,
    "name": "Gagliardini",
    "team": "Cagliari"
  },
  {
    "id": 7232,
    "name": "Fernandez T.",
    "team": "Venezia"
  },
  {
    "id": 6225,
    "name": "El Azzouzi O.",
    "team": "Bologna"
  },
  {
    "id": 6815,
    "name": "Fadera",
    "team": "Cagliari"
  },
  {
    "id": 6903,
    "name": "Hasa",
    "team": "Frosinone"
  },
  {
    "id": 6980,
    "name": "Venturino",
    "team": "Genoa"
  },
  {
    "id": 6191,
    "name": "Belahyane",
    "team": "Lazio"
  },
  {
    "id": 5880,
    "name": "Ciurria",
    "team": "Monza"
  },
  {
    "id": 7276,
    "name": "Cremaschi",
    "team": "Parma"
  },
  {
    "id": 6219,
    "name": "Boloca",
    "team": "Sassuolo"
  },
  {
    "id": 6246,
    "name": "Lipani",
    "team": "Sassuolo"
  },
  {
    "id": 6212,
    "name": "Zarraga",
    "team": "Udinese"
  },
  {
    "id": 7418,
    "name": "Chakvetadze",
    "team": "Udinese"
  },
  {
    "id": 526,
    "name": "Duncan",
    "team": "Venezia"
  },
  {
    "id": 6592,
    "name": "Forson O.",
    "team": "Monza"
  },
  {
    "id": 7574,
    "name": "Foe Ondoa",
    "team": "Monza"
  },
  {
    "id": 7092,
    "name": "Jovanovic",
    "team": "Udinese"
  },
  {
    "id": 7165,
    "name": "Liteta",
    "team": "Cagliari"
  },
  {
    "id": 7357,
    "name": "Lahdo",
    "team": "Como"
  },
  {
    "id": 7456,
    "name": "El Azzouzi A.",
    "team": "Frosinone"
  },
  {
    "id": 5725,
    "name": "Kone B.",
    "team": "Frosinone"
  },
  {
    "id": 7345,
    "name": "Przyborek",
    "team": "Lazio"
  },
  {
    "id": 6410,
    "name": "Kaba",
    "team": "Lecce"
  },
  {
    "id": 7319,
    "name": "Fofana Sa.",
    "team": "Lecce"
  },
  {
    "id": 5007,
    "name": "Ilic",
    "team": "Lecce"
  },
  {
    "id": 7481,
    "name": "Dagasso",
    "team": "Venezia"
  },
  {
    "id": 7571,
    "name": "Laerke",
    "team": "Lecce"
  },
  {
    "id": 7572,
    "name": "Comotto",
    "team": "Milan"
  },
  {
    "id": 7575,
    "name": "Mout",
    "team": "Monza"
  },
  {
    "id": 5462,
    "name": "Ciervo",
    "team": "Cagliari"
  },
  {
    "id": 7628,
    "name": "Sierro",
    "team": "Parma"
  },
  {
    "id": 5585,
    "name": "Malen",
    "team": "Roma"
  },
  {
    "id": 2764,
    "name": "Martinez L.",
    "team": "Inter"
  },
  {
    "id": 4871,
    "name": "Thuram",
    "team": "Inter"
  },
  {
    "id": 6052,
    "name": "Hojlund",
    "team": "Napoli"
  },
  {
    "id": 6397,
    "name": "Ramos G.",
    "team": "Milan"
  },
  {
    "id": 5951,
    "name": "Kolo Muani",
    "team": "Juventus"
  },
  {
    "id": 2097,
    "name": "Kean",
    "team": "Como"
  },
  {
    "id": 6752,
    "name": "Woltemade",
    "team": "Juventus"
  },
  {
    "id": 7017,
    "name": "Douvikas",
    "team": "Como"
  },
  {
    "id": 6434,
    "name": "Yildiz",
    "team": "Juventus"
  },
  {
    "id": 2137,
    "name": "Scamacca",
    "team": "Atalanta"
  },
  {
    "id": 531,
    "name": "Berardi",
    "team": "Sassuolo"
  },
  {
    "id": 5637,
    "name": "Davis K.",
    "team": "Udinese"
  },
  {
    "id": 6435,
    "name": "Krstovic",
    "team": "Atalanta"
  },
  {
    "id": 5995,
    "name": "De Ketelaere",
    "team": "Atalanta"
  },
  {
    "id": 7071,
    "name": "Esposito F.P.",
    "team": "Inter"
  },
  {
    "id": 309,
    "name": "Dybala",
    "team": "Roma"
  },
  {
    "id": 6675,
    "name": "Dovbyk",
    "team": "Bologna"
  },
  {
    "id": 6060,
    "name": "Laurientè",
    "team": "Sassuolo"
  },
  {
    "id": 4371,
    "name": "Raspadori",
    "team": "Atalanta"
  },
  {
    "id": 7351,
    "name": "Santos A.",
    "team": "Napoli"
  },
  {
    "id": 7023,
    "name": "Pellegrino M.",
    "team": "Fiorentina"
  },
  {
    "id": 6572,
    "name": "Castro S.",
    "team": "Roma"
  },
  {
    "id": 2061,
    "name": "Simeone",
    "team": "Torino"
  },
  {
    "id": 5694,
    "name": "Beto",
    "team": "Fiorentina"
  },
  {
    "id": 5734,
    "name": "Soulè",
    "team": "Roma"
  },
  {
    "id": 4463,
    "name": "Esposito Se.",
    "team": "Sassuolo"
  },
  {
    "id": 6967,
    "name": "Diao",
    "team": "Como"
  },
  {
    "id": 2038,
    "name": "Pinamonti",
    "team": "Lazio"
  },
  {
    "id": 7547,
    "name": "Kevin Carlos",
    "team": "Cagliari"
  },
  {
    "id": 4923,
    "name": "Colombo",
    "team": "Genoa"
  },
  {
    "id": 7484,
    "name": "Adams A.",
    "team": "Venezia"
  },
  {
    "id": 6646,
    "name": "Adams C.",
    "team": "Torino"
  },
  {
    "id": 6229,
    "name": "Tourè E.",
    "team": "Parma"
  },
  {
    "id": 7554,
    "name": "Romero D.",
    "team": "Parma"
  },
  {
    "id": 5436,
    "name": "Raimondo",
    "team": "Frosinone"
  },
  {
    "id": 2155,
    "name": "Cutrone",
    "team": "Monza"
  },
  {
    "id": 7347,
    "name": "Bowie",
    "team": "Sassuolo"
  },
  {
    "id": 6904,
    "name": "Yeboah J.",
    "team": "Venezia"
  },
  {
    "id": 7612,
    "name": "Bobcek",
    "team": "Frosinone"
  },
  {
    "id": 4359,
    "name": "Piccoli",
    "team": "Bologna"
  },
  {
    "id": 6530,
    "name": "Ghedjemis",
    "team": "Frosinone"
  },
  {
    "id": 6164,
    "name": "Vitinha O.",
    "team": "Genoa"
  },
  {
    "id": 5029,
    "name": "Geubbels",
    "team": "Lecce"
  },
  {
    "id": 7600,
    "name": "Osmajic",
    "team": "Genoa"
  },
  {
    "id": 6669,
    "name": "Bonny",
    "team": "Inter"
  },
  {
    "id": 2832,
    "name": "Boga",
    "team": "Juventus"
  },
  {
    "id": 7523,
    "name": "Varela G.",
    "team": "Monza"
  },
  {
    "id": 7449,
    "name": "Rrahmani Al.",
    "team": "Venezia"
  },
  {
    "id": 7623,
    "name": "Gnonto",
    "team": "Fiorentina"
  },
  {
    "id": 5918,
    "name": "Sulemana K.",
    "team": "Atalanta"
  },
  {
    "id": 6204,
    "name": "Kvernadze",
    "team": "Frosinone"
  },
  {
    "id": 6556,
    "name": "Noslin",
    "team": "Lazio"
  },
  {
    "id": 7252,
    "name": "Stulic",
    "team": "Lecce"
  },
  {
    "id": 6831,
    "name": "Neres",
    "team": "Napoli"
  },
  {
    "id": 608,
    "name": "Zapata D.",
    "team": "Torino"
  },
  {
    "id": 7620,
    "name": "Zeballos",
    "team": "Monza"
  },
  {
    "id": 4896,
    "name": "Maldini",
    "team": "Cagliari"
  },
  {
    "id": 7610,
    "name": "Birligea",
    "team": "Frosinone"
  },
  {
    "id": 6145,
    "name": "Ngonge",
    "team": "Monza"
  },
  {
    "id": 7374,
    "name": "Mendy P.",
    "team": "Cagliari"
  },
  {
    "id": 7453,
    "name": "Havel",
    "team": "Genoa"
  },
  {
    "id": 7001,
    "name": "N'Dri",
    "team": "Lecce"
  },
  {
    "id": 6519,
    "name": "Camarda",
    "team": "Milan"
  },
  {
    "id": 5882,
    "name": "Mota",
    "team": "Monza"
  },
  {
    "id": 7162,
    "name": "Giovane",
    "team": "Napoli"
  },
  {
    "id": 7120,
    "name": "Lang",
    "team": "Napoli"
  },
  {
    "id": 6215,
    "name": "Lucca",
    "team": "Napoli"
  },
  {
    "id": 7213,
    "name": "Frigan",
    "team": "Parma"
  },
  {
    "id": 7349,
    "name": "Kulenovic",
    "team": "Torino"
  },
  {
    "id": 7272,
    "name": "Gueye",
    "team": "Udinese"
  },
  {
    "id": 4387,
    "name": "Adorante",
    "team": "Venezia"
  },
  {
    "id": 7546,
    "name": "Robinson J.",
    "team": "Monza"
  },
  {
    "id": 2012,
    "name": "Milik",
    "team": "Juventus"
  },
  {
    "id": 7602,
    "name": "Fatah",
    "team": "Lecce"
  },
  {
    "id": 5336,
    "name": "Nzola",
    "team": "Cagliari"
  },
  {
    "id": 6822,
    "name": "Ekhator",
    "team": "Juventus"
  },
  {
    "id": 7342,
    "name": "Elphege",
    "team": "Parma"
  },
  {
    "id": 7561,
    "name": "Lontani",
    "team": "Parma"
  },
  {
    "id": 7627,
    "name": "Enem",
    "team": "Bologna"
  },
  {
    "id": 7317,
    "name": "Trepy",
    "team": "Cagliari"
  },
  {
    "id": 7161,
    "name": "Bayo V.",
    "team": "Udinese"
  },
  {
    "id": 7408,
    "name": "Lisman",
    "team": "Venezia"
  },
  {
    "id": 7482,
    "name": "Lauberbach",
    "team": "Venezia"
  },
  {
    "id": 7568,
    "name": "De Martis",
    "team": "Parma"
  },
  {
    "id": 7622,
    "name": "Robinho Junior",
    "team": "Genoa"
  },
  {
    "id": 5876,
    "name": "Di Gregorio",
    "team": "Juventus"
  },
  {
    "id": 6641,
    "name": "Suzuki",
    "team": "Parma"
  },
  {
    "id": 218,
    "name": "Perin",
    "team": "Juventus"
  },
  {
    "id": 2297,
    "name": "Rossi F.",
    "team": "Atalanta"
  },
  {
    "id": 4929,
    "name": "Ciocci",
    "team": "Cagliari"
  },
  {
    "id": 2401,
    "name": "Fruchtl",
    "team": "Lecce"
  },
  {
    "id": 6523,
    "name": "Samooja",
    "team": "Lecce"
  },
  {
    "id": 6682,
    "name": "Pizzignacco",
    "team": "Monza"
  },
  {
    "id": 5320,
    "name": "Paleari",
    "team": "Torino"
  },
  {
    "id": 7545,
    "name": "Vismara",
    "team": "Atalanta"
  },
  {
    "id": 6814,
    "name": "Norton-Cuffy",
    "team": "Genoa"
  },
  {
    "id": 5427,
    "name": "Gutierrez",
    "team": "Napoli"
  },
  {
    "id": 787,
    "name": "Djimsiti",
    "team": "Atalanta"
  },
  {
    "id": 6916,
    "name": "Ahanor",
    "team": "Atalanta"
  },
  {
    "id": 460,
    "name": "Romagnoli",
    "team": "Lazio"
  },
  {
    "id": 6663,
    "name": "Circati",
    "team": "Parma"
  },
  {
    "id": 6426,
    "name": "Pedersen",
    "team": "Torino"
  },
  {
    "id": 4461,
    "name": "Zappa",
    "team": "Cagliari"
  },
  {
    "id": 2593,
    "name": "Martin",
    "team": "Genoa"
  },
  {
    "id": 2115,
    "name": "Delli Carri",
    "team": "Monza"
  },
  {
    "id": 7211,
    "name": "Athekame",
    "team": "Milan"
  },
  {
    "id": 4772,
    "name": "Angelino",
    "team": "Roma"
  },
  {
    "id": 7346,
    "name": "Raterink",
    "team": "Cagliari"
  },
  {
    "id": 7407,
    "name": "Cuenca A.",
    "team": "Como"
  },
  {
    "id": 7468,
    "name": "Gelli J.",
    "team": "Frosinone"
  },
  {
    "id": 7470,
    "name": "Oyono J.",
    "team": "Frosinone"
  },
  {
    "id": 7471,
    "name": "Corrado",
    "team": "Frosinone"
  },
  {
    "id": 6245,
    "name": "Vogliacco",
    "team": "Genoa"
  },
  {
    "id": 6244,
    "name": "Matturro",
    "team": "Genoa"
  },
  {
    "id": 7164,
    "name": "Perez M.",
    "team": "Lecce"
  },
  {
    "id": 6189,
    "name": "Missori",
    "team": "Sassuolo"
  },
  {
    "id": 7356,
    "name": "Mlacic",
    "team": "Udinese"
  },
  {
    "id": 7396,
    "name": "Macchioni",
    "team": "Sassuolo"
  },
  {
    "id": 6984,
    "name": "Ondrejka",
    "team": "Parma"
  },
  {
    "id": 6424,
    "name": "Prati",
    "team": "Cagliari"
  },
  {
    "id": 7474,
    "name": "Koutsoupias",
    "team": "Frosinone"
  },
  {
    "id": 4686,
    "name": "Fofana Y.",
    "team": "Milan"
  },
  {
    "id": 6271,
    "name": "El Aynaoui",
    "team": "Roma"
  },
  {
    "id": 5813,
    "name": "Miretti",
    "team": "Juventus"
  },
  {
    "id": 7209,
    "name": "Sorensen O.",
    "team": "Parma"
  },
  {
    "id": 7157,
    "name": "Iannoni",
    "team": "Sassuolo"
  },
  {
    "id": 6889,
    "name": "Anjorin",
    "team": "Torino"
  },
  {
    "id": 7392,
    "name": "Camara A.",
    "team": "Udinese"
  },
  {
    "id": 5485,
    "name": "Bjarkason",
    "team": "Venezia"
  },
  {
    "id": 4510,
    "name": "Leao",
    "team": "Milan"
  },
  {
    "id": 4728,
    "name": "Nkunku",
    "team": "Milan"
  },
  {
    "id": 5672,
    "name": "Dia",
    "team": "Lazio"
  },
  {
    "id": 2531,
    "name": "Lukaku",
    "team": "Napoli"
  },
  {
    "id": 7313,
    "name": "Ratkov",
    "team": "Lazio"
  },
  {
    "id": 6643,
    "name": "Dallinga",
    "team": "Bologna"
  },
  {
    "id": 5544,
    "name": "David",
    "team": "Juventus"
  },
  {
    "id": 6598,
    "name": "Mutandwa",
    "team": "Cagliari"
  },
  {
    "id": 7008,
    "name": "Gimenez",
    "team": "Milan"
  },
  {
    "id": 6243,
    "name": "Borrelli",
    "team": "Cagliari"
  },
  {
    "id": 313,
    "name": "Morata",
    "team": "Como"
  },
  {
    "id": 7128,
    "name": "Kuhn",
    "team": "Como"
  },
  {
    "id": 383,
    "name": "Petagna",
    "team": "Monza"
  },
  {
    "id": 7249,
    "name": "Buksa",
    "team": "Udinese"
  },
  {
    "id": 7338,
    "name": "Albarracin",
    "team": "Cagliari"
  },
  {
    "id": 7027,
    "name": "Azon",
    "team": "Como"
  },
  {
    "id": 6981,
    "name": "Vaz",
    "team": "Roma"
  },
  {
    "id": 7158,
    "name": "Moro L.",
    "team": "Sassuolo"
  }
];
